export const DOCUMENT_TYPE_PROJECTS_FRONTPAGE = 'projectsFrontpage';
